var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentUser && _vm.currentUser.showId)?_c('div',{class:_vm.$style.devInfo},[_vm._v(" Dev: "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }